<template>
  <div class="acti">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Our Business</h4>
      <h1 class="jp-title">{{$t('acti.title')}}</h1>
    </div>
    <!-- <section class="first-section">
      <div class="company-address"></div>
      <div class="jp-line"></div>
      <div class="jp-column">
        <span class="title">{{$t('acti.name')}}</span>
        <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
          <el-col :span="9" :xs="24">
            <div class="jp-overflow-hidden t-card">
              <img :src="laboratory8" class="image w-100 technology-img">
            </div>
          </el-col>
          <el-col :span="15" :xs="24">
            <p v-html="$t('acti.content')" class="acti-introduce"></p>
          </el-col>
        </el-row>
      </div>
    </section> -->
    <section class="jp-grey-bg second-section">
      <div class="jp-line"></div>
      <div class="jp-column">
        <!-- <span class="title jp-grey-bg">{{$t('acti.name1')}}</span>
        <span class="en-common-title">Our business</span> -->
        <el-row :gutter="30" class="jp-project-content">
          <el-col :span="6" :xs="24">
            <div class="p-card acti-bg1" @click="gotoSummary(1)">
              <div class="card-text">
                <h3>{{$t('acti.businessName1')}}</h3>
                <h3 class="en-title">Advanced Materials</h3>
                <p>{{$t('acti.businessContent1')}}</p>
                <p class="en-content">Engineering-plastics/Electronic chemicals/Special synthetic rubbers/High performance fibers</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" :xs="24">
            <div class="p-card acti-bg2" @click="gotoSummary(2)">
              <div class="card-text">
                <h3>{{$t('acti.businessName2')}}</h3>
                <h3 class="en-title">Renewable Energy</h3>
                <p>{{$t('acti.businessContent2')}}</p>
                <p class="en-content">Hydrogen/Solar power/Bioenergy</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" :xs="24">
            <div class="p-card acti-bg3" @click="gotoSummary(3)">
              <div class="card-text">
                <h3>{{$t('acti.businessName3')}}</h3>
                <h3 class="en-title">Environmental Protection</h3>
                <p>{{$t('acti.businessContent3')}}</p>
                <p class="en-content">Three-wastes treatment/Carbon neutrality/Degradable material</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" :xs="24">
            <div class="p-card acti-bg4" @click="gotoSummary(4)">
              <div class="card-text">
                <h3>{{$t('acti.businessName4')}}</h3>
                <h3 class="en-title">Novel Petrochemical Technology</h3>
                <p>{{$t('acti.businessContent4')}}</p>
                <p class="en-content">Energy saving/Intelligent equipment</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import mainBg from '@/assets/img/main_bg.png';
import actiMode1 from '@/assets/img/acti-mode1.svg';
import actiMode2 from '@/assets/img/acti-mode2.svg';
import actiMode3 from '@/assets/img/acti-mode3.svg';
import actiMode4 from '@/assets/img/acti-mode4.svg';
export default {
  name: 'acti',
  data () {
    return {
      rowType: '',
      mainBg: mainBg,
      actiMode1: actiMode1,
      actiMode2: actiMode2,
      actiMode3: actiMode3,
      actiMode4: actiMode4
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
      } else {
        this.rowType = 'flex'
      }
    },
    gotoSummary(type) {
      this.$router.push({ name: 'actiEdit' , query: { type: type }})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

.acti {
  .first-section {
    position: relative;
    .el-row {
      height: 331px;
    }
  }
  .second-section {
    .card-text {
      position: absolute;
      bottom: 84px;
      color: #fff;
      width: 93%;
      height: 130px;
    }
    .en-title {
      margin-bottom: 8px;
      line-height: 21px;
      color: #bfbfbf;
    }
    .en-content {
      line-height: 19px;
      color: #bfbfbf;
    }
  }
}
section {
  padding-top: 3rem;
  h2 {
    font-size: 2rem;
    margin-top: 0;
    margin-bottom: 2rem;
  }

  .acti-introduce {
    font-size: 18px;
    margin: 0 auto;
    text-align: left;
    line-height: 2.25rem;
  }

  .jp-project-content {
    font-size: 1.4rem;
  }

  .p-card {
    width: 267px;
    transition: all 0.5s;
  }

  .jp-mode-card {
    text-align: left;
    background-color: #0070c0;
    border-radius: 15px;
    color: #fff;
    padding: 14px;
    margin-top: 1.2rem;
    img {
      width: 4.5rem;
      background-color: rgba(255, 255, 255, 0.3);
      border-radius: 12px;
      padding: 1rem;
    }
    h3 {
      font-size: 1.5rem;
      padding-bottom: 8px;
      border-bottom: 1px solid #92b3dd;
    }
    p {
      font-size: 0.875rem;
      padding-top: 8px;
    }
  }

  .business_model_en {
    .jp-mode-card {
      h3 {
        font-size: 1.125rem;
      }
    }
  }
  
  .acti-bg1 {
    background-image: url('../assets/img/actibg1.png');
    background-repeat: no-repeat;
    background-size: 100%;
    height: 482px;
  }
  .acti-bg2 {
    background-image: url('../assets/img/actibg2.png');
    background-repeat: no-repeat;
    background-size: 100%;
    height: 482px;
  }
  .acti-bg3 {
    background-image: url('../assets/img/actibg3.png');
    background-repeat: no-repeat;
    background-size: 100%;
    height: 482px;
  }
  .acti-bg4 {
    background-image: url('../assets/img/actibg4.png');
    background-repeat: no-repeat;
    background-size: 100%;
    height: 482px;
  }
  .p-card:hover {
    margin-top: -10px;
  }
}

@media (max-width: 768px) {
  section {
    .jp-project-content {
      font-size: 1.7rem;
    }
    .acti-introduce {
      width: 100%;
      line-height: 2.5rem;
      font-size: 1.6rem;
    }
    .acti-bg1,
    .acti-bg2,
    .acti-bg3,
    .acti-bg4 {
      margin-top: 1rem;
      height: 200px;
    }
    .business_model_en {
      .jp-mode-card {
        h3 {
          font-size: 1.5rem;
        }
      }
    }
    .p-card {
      width: auto;
    }
  }
  .acti {
    .second-section {
      .en-content {
        line-height: 16px;
        color: #fbfbfb;
      }
      .card-text {
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/acti.vue